import { DOCUMENT, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IconComponent } from '../../shared/icon/icon.component';
import { FlightRouteContent, ROUTE_SEARCH_ID, isInternational } from '../flight-route.model';
import { RouteCardComponent } from '../route-card/route-card.component';

/** Landing page body below the search widget: facts, copy, tips, FAQs, sidebar and related routes. */
@Component({
  selector: 'app-flight-route-body',
  imports: [DecimalPipe, IconComponent, RouteCardComponent],
  templateUrl: './flight-route-body.component.html',
  styleUrls: ['./flight-route-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightRouteBodyComponent {
  private readonly document = inject(DOCUMENT);

  readonly route = input.required<FlightRouteContent>();
  readonly related = input<FlightRouteContent[]>([]);
  readonly international = computed(() => isInternational(this.route()));

  /** Sidebar CTA: bring the prefilled search widget into view. */
  scrollToSearch(): void {
    this.document.getElementById(ROUTE_SEARCH_ID)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
